module.exports = __webpack_public_path__ + "28832b6d79fe7fa12c8d4eb391bbf6d4.pdf";